import { Route } from '@/app/router'

const CategorySets = () => import('./index.vue')

const CategorySetsProps = ['page', 'perPage']

export default new Route('/category-sets', CategorySets)
	.as('Dashboard:CategorySets')
	.props(CategorySetsProps)
	.permissions(['CREATE_CATEGORY_SET'])
